module.exports = __webpack_public_path__ + "static/img/newsh5_advertisement_01_zh.60405ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newsh5_advertisement_01_zh.png
// module id = wPH1
// module chunks = 34